module.exports = __webpack_public_path__ + "static/media/rashmiben.d8eebdf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rashmiben.jpg
// module id = 1129
// module chunks = 0